document.addEventListener('DOMContentLoaded', function () {
    var carousels = document.querySelectorAll('.image-carousel');

    for (var i = 0; i < carousels.length; i++) {
        initCarousel(carousels[i]);
    }

    function initCarousel(container) {
        var track = container.querySelector('.image-carousel__track');
        var slides = container.querySelectorAll('.image-carousel__slide');
        var prevBtn = container.querySelector('.image-carousel__nav--prev');
        var nextBtn = container.querySelector('.image-carousel__nav--next');
        var totalSlides = slides.length;
        var isTransitioning = false;

        var firstClone = slides[0].cloneNode(true);
        var lastClone = slides[totalSlides - 1].cloneNode(true);
        firstClone.classList.add('image-carousel__slide--clone');
        lastClone.classList.add('image-carousel__slide--clone');
        track.appendChild(firstClone);
        track.insertBefore(lastClone, slides[0]);

        // index 0 = lastClone, 1..totalSlides = real slides, totalSlides+1 = firstClone
        var currentIndex = 1;
        setTrackPosition(currentIndex, false);

        function setTrackPosition(index, animate) {
            if (!animate) {
                track.style.transition = 'none';
            } else {
                track.style.transition = 'transform 0.5s ease-in-out';
            }
            track.style.transform = 'translateX(-' + (index * 100) + '%)';
            if (!animate) {
                // force reflow so the non-animated jump applies immediately
                track.offsetHeight;
            }
        }

        function goToSlide(index) {
            if (isTransitioning) return;
            isTransitioning = true;
            currentIndex = index;
            setTrackPosition(currentIndex, true);
        }

        track.addEventListener('transitionend', function () {
            isTransitioning = false;
            if (currentIndex === 0) {
                currentIndex = totalSlides;
                setTrackPosition(currentIndex, false);
            } else if (currentIndex === totalSlides + 1) {
                currentIndex = 1;
                setTrackPosition(currentIndex, false);
            }
        });

        prevBtn.addEventListener('click', function () {
            goToSlide(currentIndex - 1);
        });

        nextBtn.addEventListener('click', function () {
            goToSlide(currentIndex + 1);
        });

        var startX = 0;
        var isDragging = false;

        container.addEventListener('touchstart', function (e) {
            startX = e.touches[0].clientX;
            isDragging = true;
        }, { passive: true });

        container.addEventListener('touchend', function (e) {
            if (!isDragging) return;
            isDragging = false;
            var diff = startX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 50) {
                if (diff > 0) {
                    goToSlide(currentIndex + 1);
                } else {
                    goToSlide(currentIndex - 1);
                }
            }
        }, { passive: true });
    }
});
